import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach access token from localStorage as a Bearer fallback (in case cookies get blocked)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("dt6_access_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${t}`;
  }
  return config;
});

// 401 → auto-refresh + retry once.  A stale bearer token that expires while a
// user is deep in a portal used to force a full re-login; now we transparently
// call /auth/refresh (using the refresh cookie), re-cache the new token, and
// replay the original request.  Prevents cliff-drop UX on hour-long sessions.
let refreshInFlight = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    if (
      status === 401 &&
      original &&
      !original._dt6Retried &&
      !original.url?.includes("/auth/")
    ) {
      original._dt6Retried = true;
      try {
        refreshInFlight = refreshInFlight || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        const resp = await refreshInFlight;
        refreshInFlight = null;
        const newToken = resp?.data?.access_token;
        if (newToken) localStorage.setItem("dt6_access_token", newToken);
        if (newToken) {
          original.headers = original.headers || {};
          original.headers["Authorization"] = `Bearer ${newToken}`;
        }
        return api.request(original);
      } catch (e) {
        refreshInFlight = null;
        // Fall through — original 401 gets returned to caller.
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export default api;
